import type { KrKeyword, KrMeasuredFrom, KrStat, KrSummaryItem } from './types';

export const KR_MEASURED_FROM: KrMeasuredFrom = {
  location: 'Brampton, ON L6Y 1N2',
  lastChecked: '6 hours ago',
};

export const KR_STATS: KrStat[] = [
  { key: 'page1', label: 'On page 1', value: '6', suffix: '/8', sub: 'keywords tracked', tone: 'neutral' },
  { key: 'top3', label: 'Top 3 positions', value: '2', sub: 'where most clicks happen', tone: 'success' },
  { key: 'notRanking', label: 'Not ranking', value: '2', sub: 'not on page 1', tone: 'terra' },
  { key: 'improving', label: 'Improving', value: '4', sub: 'moved up this month', tone: 'success' },
];

export const KR_KEYWORDS: KrKeyword[] = [
  {
    id: 'dentist-near-me',
    keyword: 'dentist near me',
    category: 'General',
    volume: '~4,200 searches/mo',
    leader: '#1 is Smile Central Dental',
    rank: '4',
    delta: 1,
  },
  {
    id: 'emergency-dentist',
    keyword: 'emergency dentist',
    category: 'Emergency',
    volume: '~2,800 searches/mo',
    leader: '#1 is Meadowvale Dental Care',
    rank: '2',
    delta: 0,
    detail: {
      serp: [
        {
          position: 1,
          url: 'meadowvaledental.ca/brampton-emergency-dentist',
          title: 'Emergency Dentist in Brampton - Same-Day Appointments',
          snippet:
            'Dental emergency? Meadowvale offers same-day emergency appointments in Brampton.',
        },
        {
          position: 2,
          url: 'smiledentaldowntown.com',
          title: 'Emergency Dental Services | Smile Dental Downtown',
          snippet:
            'Emergency dental care in Brampton. Walk-ins welcome. Same-day appointments.',
          you: true,
        },
        {
          position: 3,
          url: 'brightsmiles.com/emergency',
          title: '24/7 Emergency Dentist Brampton - Bright Smiles Co.',
        },
      ],
      brief: {
        comparedTo: 'Analyzed against #1 ranked Meadowvale Dental Care',
        bottomLine:
          'You are ranking #2 because of a strong localized backlink profile, but Meadowvale is edging you out due to a highly optimized, dedicated emergency landing page with specific local schema markup.',
        doingRight: [
          'Strong Domain Authority: You have 12% more high-quality local backlinks than Meadowvale.',
          'Review Momentum: Your recent review velocity (averaging 4 new reviews/week) outpaces the market.',
        ],
        gaps: [
          'Missing Local Schema: Your emergency page lacks MedicalClinic and GeoCoordinates schema markup.',
          'No Dedicated URL: You are trying to rank your homepage for this term.',
          'Weak H1 Tag: Your heading says "Emergency Dental Services" instead of "Emergency Dentist in [Neighborhood], Brampton."',
        ],
        playbook: [
          'Create a dedicated landing page with Brampton landmarks and cross-street references.',
          'Add LocalBusiness + FAQ schema for emergency-focused questions.',
          'Update your H1 to match the exact neighborhood-intent keyword.',
        ],
      },
    },
  },
  {
    id: 'teeth-whitening',
    keyword: 'teeth whitening',
    category: 'Cosmetic',
    volume: '~1,800 searches/mo',
    leader: '#1 is Bright Smiles Co.',
    rank: '6',
    delta: 2,
  },
  {
    id: 'dental-implants-cost',
    keyword: 'dental implants cost',
    category: 'Implants',
    volume: '~1,500 searches/mo',
    leader: '#1 is Smile Central Dental',
    rank: 'Not on page 1',
    delta: 0,
  },
  {
    id: 'invisalign-near-me',
    keyword: 'invisalign near me',
    category: 'Cosmetic',
    volume: '~1,200 searches/mo',
    leader: '#1 is Smile Central Dental',
    rank: '8',
    delta: -1,
  },
  {
    id: 'family-dentist',
    keyword: 'family dentist',
    category: 'General',
    volume: '~2,200 searches/mo',
    leader: '#1 is Churchville Dentistry',
    rank: '3',
    delta: 1,
  },
  {
    id: 'dentista-cerca-de-mi',
    keyword: 'dentista cerca de mi',
    category: 'Spanish',
    volume: '~650 searches/mo',
    leader: '#1 is Smile Central Dental',
    rank: 'Not on page 1',
    delta: 0,
  },
  {
    id: 'sedation-dentistry',
    keyword: 'sedation dentistry',
    category: 'Specialty',
    volume: '~420 searches/mo',
    leader: '#1 is Hilton Dental Care',
    rank: '5',
    delta: 1,
  },
];

export const KR_SUMMARY: KrSummaryItem[] = [
  {
    label: 'Biggest Opportunity',
    body: '"Dental implants cost" gets 1,500 searches/month and you have zero presence on page 1. Creating an implant pricing hub could generate 10-15 new high-value inquiries.',
  },
  {
    label: 'Quick Win',
    body: "You're #2 for \"emergency dentist.\" A dedicated page with local schema can push you to #1 and add +15 emergency patients per month.",
  },
  {
    label: 'Untapped Market',
    body: 'Spanish-language terms have low competition. A basic Spanish page set can reach 30% of your neighborhood in weeks.',
  },
];
